var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    _vm.$style.container,
    _vm.$style[`_${_vm.position}`],
    _vm.$style[`_inner-${_vm.innerPosition}`],
    _vm.$style[`_${_vm.section}`],
    {
      [_vm.$style._shown]: _vm.visible || _vm.innerVisible,
      [_vm.$style._hasCaret]: _vm.hasCaret,
      [_vm.$style._visibleOnHover]: _vm.visibleOnHover,
    },
  ],style:({
    height: _vm.height || undefined,
    width: _vm.width || undefined,
    maxHeight: _vm.maxHeight ? _vm.maxHeight : undefined,
  }),on:{"mouseenter":_vm.setInnerVisible,"mouseleave":_vm.hide}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }